<template>
        <div class="home" >
        <div class="container p-l-r-0 container-shadow">
            <div class="row">
     <UserProfile></UserProfile>
    </div>
    <div class="row content-holder">
        <div class="col-sm-3 col-md-3 col-xs-3 dashboard-sec-left" >
            <LeftNav :type="'billing'"/>
        </div>
        <div class="col-sm-9 col-md-9 col-xs-9 dashboard-sec-right" >
            <h3 class="text-left sub-head">Documents</h3>
             <table class="table table-hover roa-table">
                        <thead>
                            <tr>
                                <th>
                                    <input type="checkbox" class="selectall"/>
                                </th>
                                <th>
                                   Invoice Number
                                </th>
                                <th>
                                   Invoice Date
                                </th>
                                <th>
                                    Amount
                                </th>
                                <th>
                                    Billed to 
                                </th>
                                <th>
                                    More
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="list_present" > 
                            <tr v-for="inv in list" :key="inv.id">
                                <td scope="row">
                                    <input type="checkbox" name=""  class="inv_checkbox">
                                </td>
                                <td>
                                    {{inv.number}}
                                </td>
                                <td>
                                     {{ inv.date }}
                                </td>
                                <td>
                                    {{inv.price}}
                                </td>
                                <td>
                                    {{inv.bill_to}}
                                </td>
                                <td>
                                    <a href="javascript://" @click="Invoice(inv.number )">View</a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="6">No records</td>
                            </tr>
                        </tbody>
             </table>
         </div>
    </div>
</div>
  </div>
</template>
<script>
import LeftNav from "../layouts/leftNav.vue"
import UserProfile from "../layouts/profile-header.vue"
import invoice from "../../services/invoice"
import moment from 'moment'
export default {
    name:'billing-index',
    data(){
        return {
            list:{},
            list_present:false,
            file_path:process.env.VUE_APP_URL,
        }
    },
     components: {
        LeftNav,
        UserProfile
    },
    methods: {
        formatDate(date,format){
            return moment(date).format(format);
        },
        Invoice(subscriptionId){
            invoice.get({'subscription_id':subscriptionId,'from':'billing'})
                    .then(res=>{
                        var response = res.data;
                         const url = this.file_path + response.path + "/" + response.file;
                            const link = document.createElement("a");
                            link.href = url;
                            link.target = '_blank';
                            link.type = 'application/octet-stream';
                            link.download=response.file
                            // link.setAttribute("download", response.file); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                            // link.remove();
                    });
                    // .catch(err=>{});
        }
    },
    mounted(){
        invoice.getList({from:'bills'})
                .then(response =>
                {
                    this.list=response.data.list;
                    this.list_present =response.data.list.length>0 ? true :false;
                })
    }
}
</script>